import Error from 'components/Icons/Error';
import InfoCircle from 'components/Icons/InfoCircle';
import React, { useContext } from 'react';
import { TooltipContext } from './Tooltip';

type TooltipButtonProps = {
  variant: 'alert' | 'info';
};

const Tooltip: React.FC<TooltipButtonProps> = ({ variant }) => {
  const { setTooltipVisibility } = useContext(TooltipContext);

  return (
    <button
      className="pl2 pr0 cursor-pointer tooltip-button b-width-0"
      type="button"
      onClick={() => setTooltipVisibility(true)}
    >
      {variant === 'alert' && (
        <Error width="16px" height="16px" fill="#0074CC" />
      )}
      {variant === 'info' && <InfoCircle />}
    </button>
  );
};
export default Tooltip;
